/**
 * Update a single typography property for a specific breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type {
	ResponsiveBreakpoint,
	TypographyAttributes,
	TypographyValues,
} from '../../types';

/**
 * Update a single typography property for a specific breakpoint
 */
export const updateTypographyProperty = (
	attributes: TypographyAttributes,
	property: keyof TypographyValues,
	value: string | undefined,
	breakpoint: ResponsiveBreakpoint,
): Partial< TypographyAttributes > => {
	const currentBreakpointValues = attributes[ breakpoint ] || {};

	return {
		...attributes,
		[ breakpoint ]: {
			...currentBreakpointValues,
			[ property ]: value,
		},
	};
};
